export default "__VITE_ASSET__DxfO7Q95__"